import React, { useState } from "react";
import useInfraFormData from "../../../../components/hooks/useInfraFormData";
import { useParams } from "react-router-dom";
import { Switch, Table, Tag } from "antd";
import { currentRole } from "../../../../api/apiCallManager";
import useProfileDataStore from "../../../../zustand/store/profileDataStore";
import { useEffect } from "react";

function ClientServerEc2InstanceTable() {
  const [isServerView, setIsServerView] = useState(true);
  const userProfile = useProfileDataStore((state) => state.userProfile);

  const { id } = useParams();
  const {
    data: infraFormData,
    error: infraFormError,
    isLoading: infraFormLoading,
  } = useInfraFormData(id);
  // const filteredData = infraFormData?.filter(
  //   (item) => item.infraType === (isServerView ? "server" : "client")
  // );
  // Filter data based on infraType and, if Client_Manager, by region
  const filteredData = infraFormData?.filter((item) => {
    const matchesInfraType =
      item.infraType === (isServerView ? "server" : "client");
    const matchesRegion =
      currentRole === "Client_Manager"
        ? item.region === userProfile.userRegion
        : true;
    return matchesInfraType && matchesRegion;
  });
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    // {
    //   title: "Project ID",
    //   dataIndex: "projectId",
    //   key: "projectId",
    // },
    {
      title: "Region",
      dataIndex: "region",
      key: "region",
    },
    {
      title: "Instance Type",
      dataIndex: "instanceType",
      key: "instanceType",
    },
    // {
    //   title: "Availability Zone",
    //   dataIndex: "availabilityZone",
    //   key: "availabilityZone",
    // },
    // {
    //   title: "Project Key",
    //   dataIndex: "project_key",
    //   key: "project_key",
    // },
    // {
    //   title: "Infra Type",
    //   dataIndex: "infraType",
    //   key: "infraType",
    // },
    // {
    //   title: "VPC ID",
    //   dataIndex: "vpcId",
    //   key: "vpcId",
    // },
    // {
    //   title: "Subnet ID",
    //   dataIndex: "subnetId",
    //   key: "subnetId",
    // },
    {
      title: "Client Name",
      dataIndex: "clientName",
      key: "clientName",
      hidden: isServerView,
    },
    {
      title: "GPU",
      dataIndex: "GPU",
      key: "GPU",
      width: 20,
    },
    {
      title: "CPU",
      dataIndex: "cpu",
      key: "cpu",
    },
    {
      title: "Memory (GB)",
      dataIndex: "memory",
      // render: (memory) => `${memory / 1024} GB`,
      key: "memory",
    },
    {
      title: "Cost Per Hour ($)",
      dataIndex: "costPerHour",
      render: (item) => parseFloat(item),
      key: "costPerHour",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "_status_",
      render: (text) => <Tag className=" capitalize">{text || "none"}</Tag>, // Render as link
    },
    // {
    //   title: "Branch",
    //   dataIndex: "branch",
    //   key: "branch",
    // },
    // {
    //   title: "Created At",
    //   dataIndex: "created_at",
    //   key: "created_at",
    // },
    // {
    //   title: "Updated At",
    //   dataIndex: "updated_at",
    //   key: "updated_at",
    // },
  ];
  // Toggle switch handler
  const handleSwitchChange = (checked) => {
    setIsServerView(checked);
  };
  useEffect(() => {
    if (currentRole == "Client_Manager") {
      setIsServerView(false);
    }
  });

  return (
    <div>
      {/* {JSON.stringify(userProfile.userRegion)}

      {currentRole == "Client_Manager"} */}

      <div className="p-2">
        <div className="flex justify-end mb-4">
          {currentRole === "Client_Manager" ? (
            ""
          ) : (
            <Switch
              checkedChildren="Server"
              unCheckedChildren="Client"
              defaultChecked
              onChange={handleSwitchChange}
            />
          )}
        </div>
        <Table
          bordered
          scroll={{ x: 600 }}
          className="user-table-theme"
          loading={infraFormLoading}
          dataSource={filteredData}
          columns={columns}
          rowKey={(record) => record.record_id} // unique key for each row
          pagination={{ pageSize: 5 }} // Optional: controls the number of rows per page
        />
      </div>
    </div>
  );
}

export default ClientServerEc2InstanceTable;
